import { useState } from 'react';

const FALLBACK = 'https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=400';

export const BlurImage = ({ src, thumbnail, alt, className = '', ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const imgSrc = error ? FALLBACK : (src || FALLBACK);
  const thumbSrc = thumbnail || null;

  return (
    <div className={`relative overflow-hidden ${className}`} {...props}>
      {/* Blur placeholder — renders instantly from inline base64 */}
      {thumbSrc && !loaded && (
        <img
          src={thumbSrc}
          alt=""
          className="absolute inset-0 w-full h-full object-cover scale-110"
          style={{ filter: 'blur(12px)' }}
          aria-hidden="true"
        />
      )}
      {/* Full image — fades in when loaded */}
      <img
        src={imgSrc}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
};
